"use client"
import Script from "next/script";

export default function ZEInitializer() {

    return (
        <Script id="ze-snippet"
                src="https://static.zdassets.com/ekr/snippet.js?key=b8b74ac3-f27f-4e28-aeae-b3bbcd97af37"
                strategy={'afterInteractive'}/>
    )
}
